import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { ContratoService, MonedaService, MenuFuncionService, TenantService, IncidenciaUsuarioService, AlicuotaIvaService, ComunidadService, MovimientoService } from '../../../../src/app/shared/services';
import { Moneda, Contrato, MenuFuncionCodes, SaveContratoDto, SearchMonedaRequest, TipoContrato, DialogUnidadFuncionalGestionRequestDto, TenantFeatureFlags, DialogCargaMovimientoItem } from '../../../../src/app/shared/model';
import { DialogUnidadFuncionalGestionResponseDto, DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto, ContratoPersona, DialogPersonaGestionResponseDto } from '../../../../src/app/shared/model';
import { DialogPersonaGestionRequestDto, LocalStorageKeys, SearchIncidenciaUsuarioRequestDto, IncidenciaUsuario, DialogCargaMovimientoResponse, SearchComunidadRequest, Comunidad } from '../../../../src/app/shared/model';
import { DialogCargaMovimientoRequest, SaveContratoMovimientoDto, SearchAlicuotaIvaRequest, AlicuotaIva, ContratoUnidadFuncional, SearchMovimientoRequest, SearchMovimientoItemDto } from '../../../../src/app/shared/model';
import { DialogUnidadFuncionalSearchComponentRequestDto, DialogUnidadFuncionalSearchComponentResponseDto } from '../../../../src/app/shared/model';

import { DialogUnidadFuncionalSearchComponent } from '../unidad-funcional/components/dialogUnidadFuncionalSearch.component';
import { DialogUnidadFuncionalGestionComponent } from '../unidad-funcional/components/dialogUnidadFuncionalGestion.component';
import { DialogPersonaSearchComponent } from '../usuarios/components/dialogPersonaSearch.component';
import { DialogPersonaGestionComponent } from '../usuarios/components/dialogPersonaGestion.component';
import { DialogCargaMovimientoComponent } from '../movimientos/components/dialogCargaMovimiento.component';

@Component({
  selector: 'app-contratoEdit',
  templateUrl: './contratoEdit.component.html',
  styleUrls: ['./contratoEdit.component.scss']
})

export class ContratoEditComponent implements OnInit {

  @ViewChild('gridUf')
  public gridUf: GridComponent;
  @ViewChild('gridPersona')
  public gridPersona: GridComponent;

  formGroup: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoSearching: boolean = false;
  isAttachmentSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isUnidadesFuncionalesSearching: boolean = false;
  isPersonasSearching: boolean = false;
  isTipoContratoSearching: boolean = false;
  isIncidenciasSearching: boolean = false;
  isMonedaSearching: boolean = false;
  isAlicuotaIvaSearching: boolean = false;
  isFileAttaching: boolean = false;
  isDeudaSaving: boolean = false;
  isMovimientosSearching: boolean = false;

  canAdd: boolean = false;
  canEdit: boolean = false;
  canDelete: boolean = false;
  canView: boolean = false;
  canViewIncidencias: boolean = false;

  canUfAny: boolean = false;
  canUfAlta: boolean = false;
  canUfEdicion: boolean = false;
  canPersonaAny: boolean = false;
  canPersonaAlta: boolean = false;
  canPersonaEdicion: boolean = false;
  canMovimientoAdd: boolean = false;
  canMovimientoView: boolean = false;

  msgError: string = "";
  item: Contrato;

  montoIva: number = 0;
  montoTotal: number = 0;

  comunidadList: Comunidad[];
  alicuotaIvaList: AlicuotaIva[];
  tipoContratoList: TipoContrato[];
  monedaList: Moneda[];
  incidenciasList: IncidenciaUsuario[];
  movimientoList: SearchMovimientoItemDto[];

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tenantService: TenantService,
    private monedaService: MonedaService,
    private alicuotaIvaService: AlicuotaIvaService,
    private comunidadService: ComunidadService,
    private incidenciaUsuarioService: IncidenciaUsuarioService,
    private movimientoService: MovimientoService,
    private contratoService: ContratoService) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.CONTRATO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.CONTRATO_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.CONTRATO_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.CONTRATO_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.CONTRATO_DELETE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.isValidating = false;
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();

    this.puedeVerIncidencias();

    this.getComunidades();
    this.getMonedas();
    this.getTipos();
    this.getAlicuotaIva();
  
    this.loadEntity();

    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.canUfAny = data.Result != null && data.Result.length > 0;
        this.canUfAlta = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_ADD);
        this.canUfEdicion = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_EDIT);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenuPadre(MenuFuncionCodes.PERSONA).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.canPersonaAny = data.Result != null && data.Result.length > 0;
        this.canPersonaAlta = data.Result.some(x => x == MenuFuncionCodes.PERSONA_ADD);
        this.canPersonaEdicion = data.Result.some(x => x == MenuFuncionCodes.PERSONA_EDIT);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenuPadre(MenuFuncionCodes.MOVIMIENTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.canMovimientoAdd = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_DEUDA);
        this.canMovimientoView = data.Result.some(x => x == MenuFuncionCodes.MOVIMIENTO_LIST);
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Codigo': [null, [Validators.required, Validators.maxLength(100)]],
      'TipoContrato': [true, Validators.required],
      'FechaInicio': [new Date(), Validators.required],
      'FechaFin': [null],
      'ComunidadId': [null, Validators.required],
      'AlicuotaIvaId': [null],
      'MonedaId': [null, Validators.required],
      'MontoBase': [0],
      'Observaciones': [null, Validators.maxLength(300)],
      'Activo': [true, Validators.required]
    });
  }

//#region Incidencias

  getIncidencias(id: number) {
    var r = new SearchIncidenciaUsuarioRequestDto(null, null, true, "FechaUltimoMensaje", null, null, null, null, null, null, null, null, null, null, id, null, null, null, null, null);
    this.isIncidenciasSearching = true;

    this.incidenciaUsuarioService.search(r).subscribe(data => {
      this.isIncidenciasSearching = false;
      this.incidenciasList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isIncidenciasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  viewIncidencia(id: number) {
    if (id == null || id <= 0) {
        this.sharedFunctions.showMessage("Debe seleccionar un incidente para continuar", "Error");
        return false;
    }

    this.router.navigate(['incidencia-usuario-edit', id]);
  }

  puedeVerIncidencias() {
    this.menuService.checkMenu(MenuFuncionCodes.INCIDENCIA_USUARIO_LIST).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewIncidencias = this.canViewIncidencias || data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });

    this.menuService.checkMenu(MenuFuncionCodes.INCIDENCIA_USUARIO_LIST_BO).subscribe(data => {
      if (data != null && data.Success && data?.Result)
        this.canViewIncidencias = this.canViewIncidencias || data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

//#endregion

//#region Contrato

  getTipos() {
    this.isTipoContratoSearching = true;
    this.contratoService.getTipos().subscribe(data => {
      this.isTipoContratoSearching = false;
      if (data != null)
        this.tipoContratoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoContratoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      if (data != null)
        this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var loggedUser = this.sharedFunctions.getLoggedUser();
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, loggedUser?.PersonaId ?? 0, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null) {
        this.comunidadList = data?.result;
        if(data.result.length == 1)
          this.formGroup.controls['ComunidadId'].setValue(data.result[0].Id);
      }
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAlicuotaIva() {
    this.isAlicuotaIvaSearching = true;
    var r = new SearchAlicuotaIvaRequest(null,null,null,null,null,null,null,null,true);

    this.alicuotaIvaService.search(r).subscribe((data)=>{
      this.isAlicuotaIvaSearching = false;
      this.alicuotaIvaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isAlicuotaIvaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.formGroup.get(formFieldName) != null && this.formGroup.get(formFieldName)?.value)
        this.formGroup.get(formFieldName)?.setValue(null);
    }
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          this.isSearching = true;
          this.contratoService.get(id).subscribe(data => {
            this.isSearching = false;
            if (data != null && data.Success) {
              this.item = data.Result;

              if (this.item != null && this.item.Id > 0) {
                this.loadAttachments(this.item.Id);
                this.loadPersonas(this.item.Id);
                this.loadUnidadesFuncionales(this.item.Id);

                this.getMovimientos(this.item.Id);
                this.getIncidencias(this.item.Id);

                if (this.canEdit) {
                  this.formGroup.patchValue(this.item);
                }

                this.montoIva = this.item.MontoAlicuotaIva;
                this.montoTotal = this.item.Monto ?? 0;
              }
              else
                this.msgError = "No se encontró el item seleccionado.";
            }
            else
              this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
          },
          (err: HttpErrorResponse) => {
            this.isSearching = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
        else
          this.msgError = "Item no válido.";
      }
      else
      {
        this.item = new Contrato( 0, null, 0, new Date(), null, 0, null, null, 0, 0, null, null, null, true, [], [], []);
        this.formGroup.patchValue(this.item);
      }
    });
  }

  getErrorTipoContrato() {
    return this.formGroup.get('TipoContrato')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorComunidad() {
    var v = this.formGroup.get('ComunidadId');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorFechaInicio() {
    return this.formGroup.get('FechaInicio')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorFechaFin() {
    return this.formGroup.get('FechaFin')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorMonedaId() {
    return this.formGroup.get('MonedaId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorMontoBase() {
    return this.formGroup.get('MontoBase')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorObservaciones() {
    var v = this.formGroup.get('Observaciones');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  loadAttachments(id) {
    this.isAttachmentSearching = true;
    this.contratoService.getAttachments(id).subscribe(data => {
      this.isAttachmentSearching = false;
      this.item.Adjuntos = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isAttachmentSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onAlicuotaIvaSelect() {
    this.calcularMontos();
  }

  calcularMontos() {
    var alicuota = this.alicuotaIvaList?.find(f => f.Id == this.formGroup.get("AlicuotaIvaId")?.value);
    if (alicuota != null && alicuota.Id > 0) {
      this.montoIva = ((this.formGroup.get("MontoBase")?.value ?? 0) * (alicuota.Porcentaje ?? 0 / 100));
      this.montoTotal = (this.formGroup.get("MontoBase")?.value ?? 0) + this.montoIva;
    }
    else {
      this.montoIva = 0;
      this.montoTotal = 0;
    }
  }

//#endregion

//#region UFs

  loadUnidadesFuncionales(id) {
    this.isUnidadesFuncionalesSearching = true;
    this.contratoService.getUnidadesFuncionales(id).subscribe(data => {
      this.isUnidadesFuncionalesSearching = false;
      this.item.UnidadesFuncionales = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isUnidadesFuncionalesSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onUfSearchClick() {
    var comunidadId = this.formGroup.get("ComunidadId")?.value;
    if (comunidadId == null || comunidadId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar " + this.sharedFunctions.getNombreMenuTenant("Comunidad") + " antes de continuar", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogUnidadFuncionalSearchComponent, {
      width: '90%',
      data: new DialogUnidadFuncionalSearchComponentRequestDto(true, 0, { ComunidadId: comunidadId })
    });

    dialogRef.afterClosed().subscribe((result: DialogUnidadFuncionalSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled && result.Items != null) {

        if (result.Items.some(f => f.ComunidadId != this.formGroup.get("ComunidadId")?.value)) {
          this.sharedFunctions.showMessage("Hay items que tienen diferente " + this.sharedFunctions.getNombreMenuTenant("Comunidad") + " que el " + + this.sharedFunctions.getNombreMenuTenant("Contrato"), "Error");
          return false;
        }

        for (var i=0; i<result.Items.length; i++) {
          var index = this.item.UnidadesFuncionales.findIndex(f => f.UnidadFuncionalId == result.Items[i].Id);
          if (index >= 0)
            this.item.UnidadesFuncionales[index] = new ContratoUnidadFuncional(this.item.UnidadesFuncionales[index].Id, result.Items[i].Id, result.Items[i].Codigo, 
              result.Items[i].Numero ?? 0, result.Items[i].TipoUnidadNombre, result.Items[i].CantidadAmbientes, result.Items[i].NroPiso, result.Items[i].Comunidad, 
              result.Items[i].Consorcio, this.item.UnidadesFuncionales[index].ContratoId, (result.Items[i].Precio ?? 0));
          else
            this.item.UnidadesFuncionales.push(new ContratoUnidadFuncional(0, result.Items[i].Id, result.Items[i].Codigo, 
              result.Items[i].Numero ?? 0, result.Items[i].TipoUnidadNombre, result.Items[i].CantidadAmbientes, result.Items[i].NroPiso, result.Items[i].Comunidad, 
              result.Items[i].Consorcio, this.item.Id, (result.Items[i].Precio ?? 0)));
        }

        this.gridUf.refresh();
      }
    });
  }

  onUfNewClick() {
    var comunidadId = this.formGroup.get("ComunidadId")?.value;
    if (comunidadId == null || comunidadId <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar " + this.sharedFunctions.getNombreMenuTenant("Comunidad") + " antes de continuar", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogUnidadFuncionalGestionComponent, {
      width: '90%',
      data: new DialogUnidadFuncionalGestionRequestDto(0, { ComunidadId: comunidadId })
    });

    dialogRef.afterClosed().subscribe((result: DialogUnidadFuncionalGestionResponseDto) => {
      if (result != null && !result.Cancelled) {
        if (result.Item != null && result.Item.Id > 0) {

          if (result.Item.ComunidadId != this.formGroup.get("ComunidadId")?.value) {
            this.sharedFunctions.showMessage("El item tiene diferente " + this.sharedFunctions.getNombreMenuTenant("Comunidad") + " que el " + + this.sharedFunctions.getNombreMenuTenant("Contrato"), "Error");
            return false;
          }

          var index = this.item.UnidadesFuncionales.findIndex(f => f.UnidadFuncionalId == (result?.Item?.Id ?? 0));
          if (index >= 0) {
            this.item.UnidadesFuncionales[index] = new ContratoUnidadFuncional(this.item.UnidadesFuncionales[index].Id, result.Item.Id, result.Item.Codigo, 
              result.Item.Numero ?? 0, result.Item.TipoUnidadNombre, result.Item.CantidadAmbientes, result.Item.NroPiso, result.Item.Comunidad, 
              result.Item.Consorcio, this.item.UnidadesFuncionales[index].ContratoId, (result.Item.Precio ?? 0));
          }
          else {
            this.item.UnidadesFuncionales.push(new ContratoUnidadFuncional(0, result.Item.Id, result.Item.Codigo, result.Item.Numero ?? 0, result.Item.TipoUnidadNombre, 
              result.Item.CantidadAmbientes, result.Item.NroPiso, result.Item.Comunidad, result.Item.Consorcio, this.item.Id, (result.Item.Precio ?? 0)));
          }

          this.gridUf.refresh();
        }
        else
          this.sharedFunctions.showMessage("No se pudo dar de alta la unidad funcional", "Error");
      }
    });
  }

  onUfGridFieldChange(ufId: number, event: any) {
    if (ufId != null && ufId > 0 && this.item.Personas != null) {
      var index = this.item.UnidadesFuncionales.findIndex(f => f.UnidadFuncionalId == ufId);

      if (index >= 0) {
        switch (event.target.name) {
          case "Importe":
            this.item.UnidadesFuncionales[index].Importe = event.target.value;
            break;
        }

        this.gridUf.refresh();
      }
    }
  }

  viewUf(data: any) {
    if (data == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    if (this.canUfAny)
      this.router.navigate(['unidad-funcional-edit', data.UnidadFuncionalId]);
    else
      this.sharedFunctions.showMessage("No tiene permisos para realizar esta operación", "Error");
  }

  editUf(data: any) {
    if (data == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogUnidadFuncionalGestionComponent, {
      width: '90%',
      data: new DialogUnidadFuncionalGestionRequestDto((data?.Id ?? 0), null)
    });

    dialogRef.afterClosed().subscribe((result: DialogUnidadFuncionalGestionResponseDto) => {
      if (result != null && !result.Cancelled) {
        if (result.Item != null && result.Item.Id > 0) {
          var index = this.item.UnidadesFuncionales.findIndex(f => f.UnidadFuncionalId == (result?.Item?.Id ?? 0));
          if (index >= 0) {
            this.item.UnidadesFuncionales[index] = new ContratoUnidadFuncional(this.item.UnidadesFuncionales[index].Id, result.Item.Id, result.Item.Codigo, 
              result.Item.Numero ?? 0, result.Item.TipoUnidadNombre, result.Item.CantidadAmbientes, result.Item.NroPiso, result.Item.Comunidad, 
              result.Item.Consorcio, this.item.UnidadesFuncionales[index].ContratoId, (result.Item.Precio ?? 0));
          }
          else {
            this.item.UnidadesFuncionales.push(new ContratoUnidadFuncional(0, result.Item.Id, result.Item.Codigo, result.Item.Numero ?? 0, 
              result.Item.TipoUnidadNombre, result.Item.CantidadAmbientes, result.Item.NroPiso, result.Item.Comunidad, 
              result.Item.Consorcio, this.item.Id, (result.Item.Precio ?? 0)));
          }

          this.gridUf.refresh();
        }
        else
          this.sharedFunctions.showMessage("No se pudo dar de alta la unidad funcional", "Error");
      }
    });
  }

  deleteUf(data: any) {
    if (data == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    if (this.item.UnidadesFuncionales == null)
      this.item.UnidadesFuncionales = [];

    if (this.item.UnidadesFuncionales.length > 0) {
      var index = this.item.UnidadesFuncionales.findIndex(f => f.UnidadFuncionalId == data.UnidadFuncionalId);
      if (index >= 0) {
        this.item.UnidadesFuncionales.splice(index, 1);
        this.gridUf.refresh();
      }
    }
  }

  sumUfImporte() {
    var v = this.item.UnidadesFuncionales?.reduce(function (accumulator, item) {
      return accumulator + (item.Importe != null ? parseFloat(item.Importe.toString()) : 0);
    }, 0);

    return (v ?? 0);
  }

//#endregion

//#region Personas

  loadPersonas(id) {
    this.isPersonasSearching = true;
    this.contratoService.getPersonas(id).subscribe(data => {
      this.isPersonasSearching = false;
      if (data.Success)
        this.item.Personas = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isPersonasSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  onPersonaSearchClick() {
    const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
      width: '90%',
      data: new DialogPersonaSearchComponentRequestDto(true, 0)
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled && result.Items != null) {

        for (var i=0; i<result.Items.length; i++) {
          var index = this.item.Personas.findIndex(f => f.Id == result.Items[i].Id);
          if (index >= 0) {
            this.item.Personas[index] = new ContratoPersona(this.item.Personas[index].Id, result.Items[i].Id ?? 0, result.Items[i].Nombre, result.Items[i].Apellido,
              result.Items[i].TipoDocumentoNombre, result.Items[i].NroDocumento, result.Items[i].Cuit, result.Items[i].MailContacto, result.Items[i].MovilContacto,
              this.item.Personas[index].ContratoId, this.item.Personas[index].Porcentaje, this.item.Personas[index].PuedeEnviarInvitacion);
          }
          else {
            this.item.Personas.push(new ContratoPersona(0, result.Items[i].Id ?? 0, result.Items[i].Nombre, result.Items[i].Apellido,
              result.Items[i].TipoDocumentoNombre, result.Items[i].NroDocumento, result.Items[i].Cuit, result.Items[i].MailContacto, result.Items[i].MovilContacto,
              this.item.Id, 0, false));
          }
        }

        if (this.item.Personas.length == 1)
          this.item.Personas[0].Porcentaje = 100;

        this.gridPersona.refresh();
      }
    });
  }

  onPersonaNewClick() {
    const dialogRef = this.dialog.open(DialogPersonaGestionComponent, {
      width: '90%',
      data: new DialogPersonaGestionRequestDto(0)
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaGestionResponseDto) => {
      if (result != null && !result.Cancelled) {
        if (result.Item != null && (result?.Item?.Id ?? 0) > 0) {
          var index = this.item.Personas.findIndex(f => f.PersonaId == (result?.Item?.Id ?? 0));
          if (index >= 0) {
            this.item.Personas[index] = new ContratoPersona(this.item.Personas[index].Id, (result?.Item?.Id ?? 0), result.Item.Nombre, result.Item.Apellido,
              result.Item.TipoDocumentoNombre, result.Item.NroDocumento, result.Item.Cuit, result.Item.MailContacto, result.Item.MovilContacto,
              this.item.Personas[index].ContratoId, this.item.Personas[index].Porcentaje, this.item.Personas[index].PuedeEnviarInvitacion);
          }
          else {
            this.item.Personas.push(new ContratoPersona(0, (result?.Item?.Id ?? 0), result.Item.Nombre, result.Item.Apellido,
              result.Item.TipoDocumentoNombre, result.Item.NroDocumento, result.Item.Cuit, result.Item.MailContacto, result.Item.MovilContacto,
              this.item.Id, (this.item.Personas.length > 1 ? 0 : 100), false));
          }

          if (this.item.Personas.length == 1)
            this.item.Personas[0].Porcentaje = 100;
          
          this.gridPersona.refresh();
        }
        else
          this.sharedFunctions.showMessage("No se pudo dar de alta la persona", "Error");
      }
    });
  }

  viewPersona(data: any) {
    if (data == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    if (this.canPersonaAny)
      this.router.navigate(['persona-edit', data.PersonaId]);
    else
      this.sharedFunctions.showMessage("No tiene permisos para realizar esta operación", "Error");
  }

  editPersona(data: any) {
    if (data == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogPersonaGestionComponent, {
      width: '90%',
      data: new DialogPersonaGestionRequestDto((data?.PersonaId ?? 0))
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaGestionResponseDto) => {
      if (result != null && !result.Cancelled) {
        if (result.Item != null && (result?.Item?.Id ?? 0) > 0) {
          var index = this.item.Personas.findIndex(f => f.PersonaId == (result?.Item?.Id ?? 0));
          if (index >= 0) {
            this.item.Personas[index] = new ContratoPersona(this.item.Personas[index].Id, (result?.Item?.Id ?? 0), result.Item.Nombre, result.Item.Apellido,
              result.Item.TipoDocumentoNombre, result.Item.NroDocumento, result.Item.Cuit, result.Item.MailContacto, result.Item.MovilContacto,
              this.item.Personas[index].ContratoId, this.item.Personas[index].Porcentaje, this.item.Personas[index].PuedeEnviarInvitacion);
          }
          else {
            this.item.Personas.push(new ContratoPersona(0, (result?.Item?.Id ?? 0), result.Item.Nombre, result.Item.Apellido,
              result.Item.TipoDocumentoNombre, result.Item.NroDocumento, result.Item.Cuit, result.Item.MailContacto, result.Item.MovilContacto,
              this.item.Id, (this.item.Personas.length > 1 ? 0 : 100), false));
          }

          this.gridPersona.refresh();
        }
        else
          this.sharedFunctions.showMessage("No se pudo dar de alta la persona", "Error");
      }
    });
  }

  deletePersona(data: any) {
    if (data == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    if (this.item.Personas == null)
      this.item.Personas = [];

    if (this.item.Personas.length > 0) {
      var index = this.item.Personas.findIndex(f => f.PersonaId == data.PersonaId);
      if (index >= 0) {
        this.item.Personas.splice(index, 1);
        this.gridPersona.refresh();
      }
    }
  }

  sendInvite(item: any) {
    if (item == null) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    if (item.PersonaMailContacto == null || item.PersonaMailContacto.length == 0) {
      this.sharedFunctions.showMessage("La persona no tiene configurado un mail para realizar el envio", "Error");
      return false;
    }

    this.contratoService.sendNewUserInvitation(item).subscribe(data => {
      if (data.Success && data.Result == true) {
        this.sharedFunctions.showMessage("Se envió correctamente un correo de invitación al correo " + item.PersonaMailContacto, "Operación Exitosa!");
      }
      else {
        this.sharedFunctions.showMessage("Ocurrió un error enviando el mail de invitación al usuario.", "Error");
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err, true);
    });
  }

  onPersonaGridFieldChange(personaId: number, event: any) {
    if (personaId != null && personaId > 0 && this.item.Personas != null) {
      var index = this.item.Personas.findIndex(f => f.PersonaId == personaId);

      if (index >= 0) {
        switch (event.target.name) {
          case "Porcentaje":
            this.item.Personas[index].Porcentaje = event.target.value;
            break;
        }

        this.gridPersona.refresh();
      }
    }
  }

  calcularPorcentajes() {
    if (this.item.Personas != null && this.item.Personas.length > 0) {
      var porcentaje = (100 / this.item.Personas.length);
      for (var i=0; i<this.item.Personas.length; i++)
        this.onPersonaGridFieldChange(this.item.Personas[i].PersonaId, { target: { name: "Porcentaje", value: porcentaje } });
    }
  }

  sumPersonaPorcentaje() {
    var v = this.item.Personas?.reduce(function (accumulator, item) {
      return accumulator + (item.Porcentaje != null ? parseFloat(item.Porcentaje.toString()) : 0);
    }, 0);

    return (v ?? 0);
  }

//#endregion

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    // if (this.tenantFeatureFlags?.HabilitarControlCaja && !this.tieneMovimientoAsociado())
    //   this.openDialogCargaMovimiento(true);
    // else
    var m = [
      new DialogCargaMovimientoItem(0, this.montoTotal, null, 1, this.formGroup.get("FechaInicio")?.value, 0, 0, false, false, null, null)
    ];
    
    this.doSaveContrato(m);
  }

  doSaveContrato(datosMovimiento: DialogCargaMovimientoItem[] = []) {
    var r = new SaveContratoDto(0, null, 0, new Date(), null, 0, null, 0, null, null, true, [], [], []);

    if (this.item.Adjuntos == null)
      this.item.Adjuntos = [];

    r = 
    {
      ...this.formGroup.value,
      ... {
        Id: (this.item?.Id ?? 0),
        Activo: (this.item?.Activo ?? true),
        Adjuntos: this.item?.Adjuntos,
        UnidadesFuncionales: this.item?.UnidadesFuncionales,
        Personas: this.item?.Personas,
        Deudas: datosMovimiento
      }
    };

    this.isSaving = true;
    this.contratoService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.location.back();
  }

//#region Adjuntos

  onFileAttachedDelete(item: any) {
    if (item.Id > 0)
      this.onExistingFileAttachedDelete(item);
    else
      this.onNewFileAttachedDelete(item);
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (this.item.Adjuntos == null)
        this.item.Adjuntos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
          this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.contratoService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                this.item.Adjuntos.push(data.Result.Archivos[i]);
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

//#endregion

//#region Movimientos

  getMovimientos(id: number) {
    var r = new SearchMovimientoRequest(null, null, true, "FechaMovimiento", null, null, null, null, null, null, null, null, null, null, null, null, 
      null, null, null, null, id, null, null, null, null, null, null, null, null, null, null, true, false, null);
    this.isMovimientosSearching = true;

    this.movimientoService.search(r).subscribe(data => {
      this.isMovimientosSearching = false;
      this.movimientoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMovimientosSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  puedeVerMovimiento() {
    return (this.item != null && this.item.Id > 0 && this.tenantFeatureFlags?.HabilitarControlCaja && this.canMovimientoView);
  }

  openDialogCargaMovimiento(esGuardado: boolean) {
    const dialogRef = this.dialog.open(DialogCargaMovimientoComponent, {
      width: '80%',
      data: new DialogCargaMovimientoRequest(
        "Creación del Movimiento de Deuda Asociado", 
        "<b>Se crearán movimientos asociados al contrato que está guardando para el control de caja.</b><br/><br/>" +
            "Por favor complete los siguientes datos para poder llevar a cabo la carga de los movimientos:", 
        "Asociar Movimientos", 
        "No quiero generar movimientos",
        this.monedaList.find(f => f.Id == this.formGroup.get("MonedaId")?.value)?.Codigo ?? "",
        this.montoTotal,
        this.formGroup.get("FechaInicio")?.value
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogCargaMovimientoResponse) => {
      if (result != null && result.Accepted) {
        this.formGroup.patchValue(result);

        if (esGuardado)
          this.doSaveContrato(result.Movimientos);
        else
          this.doCrearMovimientoDeuda(result.Movimientos);
      }
    });
  }

  onCrearMovimientoDeuda() {
    this.openDialogCargaMovimiento(false);
  }

  doCrearMovimientoDeuda(datosMovimiento: DialogCargaMovimientoItem[]) {
    var r = new SaveContratoMovimientoDto(this.item.Id, datosMovimiento);
    this.isDeudaSaving = true;

    this.contratoService.crearMovimiento(r).subscribe(data => {
      this.isDeudaSaving = false;
      if (data != null && data.Success) {
        this.sharedFunctions.showMessage("Se generó éxitosamente el movimiento!", "Operación Exitosa!");
        this.sharedFunctions.reloadCurrentRoute();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando crear el movimiento", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isDeudaSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  tieneMovimientoAsociado() {
    return (this.item != null && this.item.Id > 0 && this.movimientoList != null && this.movimientoList.length > 0);
  }

  viewMovimiento(item: any) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    if (!this.canMovimientoView) {
      this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
      return false;
    }

    this.router.navigate(['movimiento-view', item.Id]);
  }

//#endregion
}
